import {defineComponent} from "./utils/component";
import DataTable from "./component/DataTable";

export {defineComponent, DataTable}
export {FilterableOpts, SummableOpts, ExportableOpts, PaginateOpts, AjaxOpts} from "./declarations"
